import { isIOSEmbeddedAndStandalone } from '../client';
import { DEFAULT_ANIMATED_DIGITS_LABEL_TRANSITION_DURATION } from '../components/AnimatedDigitsLabel/AnimatedDigitsLabel';
import { ObjectValuesUnionType } from '../utils/typing';

export const VibrationPatterns = Object.freeze({
  QUICK: isIOSEmbeddedAndStandalone ? 30 : 40,
  NORMAL: 400,
  LONG: 750,
  BANKROLL_CHANGED: DEFAULT_ANIMATED_DIGITS_LABEL_TRANSITION_DURATION,
});

export type VibrationPattern = ObjectValuesUnionType<typeof VibrationPatterns>;
